var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4357_3558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4357_3558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8327 9.66797V6.66797C10.8327 6.43186 10.7528 6.23394 10.5931 6.07422C10.4334 5.9145 10.2355 5.83464 9.99935 5.83464C9.76324 5.83464 9.56532 5.9145 9.4056 6.07422C9.24588 6.23394 9.16602 6.43186 9.16602 6.66797V9.98047C9.16602 10.0916 9.18685 10.1992 9.22852 10.3034C9.27018 10.4076 9.33268 10.5013 9.41602 10.5846L12.166 13.3346C12.3188 13.4874 12.5132 13.5638 12.7493 13.5638C12.9855 13.5638 13.1799 13.4874 13.3327 13.3346C13.4855 13.1819 13.5618 12.9874 13.5618 12.7513C13.5618 12.5152 13.4855 12.3207 13.3327 12.168L10.8327 9.66797ZM9.99935 18.3346C8.84657 18.3346 7.76324 18.1159 6.74935 17.6784C5.73546 17.2409 4.85352 16.6471 4.10352 15.8971C3.35352 15.1471 2.75977 14.2652 2.32227 13.2513C1.88477 12.2374 1.66602 11.1541 1.66602 10.0013C1.66602 8.84852 1.88477 7.76519 2.32227 6.7513C2.75977 5.73741 3.35352 4.85547 4.10352 4.10547C4.85352 3.35547 5.73546 2.76172 6.74935 2.32422C7.76324 1.88672 8.84657 1.66797 9.99935 1.66797C11.1521 1.66797 12.2355 1.88672 13.2493 2.32422C14.2632 2.76172 15.1452 3.35547 15.8952 4.10547C16.6452 4.85547 17.2389 5.73741 17.6764 6.7513C18.1139 7.76519 18.3327 8.84852 18.3327 10.0013C18.3327 11.1541 18.1139 12.2374 17.6764 13.2513C17.2389 14.2652 16.6452 15.1471 15.8952 15.8971C15.1452 16.6471 14.2632 17.2409 13.2493 17.6784C12.2355 18.1159 11.1521 18.3346 9.99935 18.3346ZM9.99935 16.668C11.8466 16.668 13.4195 16.0187 14.7181 14.7201C16.0167 13.4214 16.666 11.8485 16.666 10.0013C16.666 8.15408 16.0167 6.58116 14.7181 5.28255C13.4195 3.98394 11.8466 3.33464 9.99935 3.33464C8.15213 3.33464 6.57921 3.98394 5.2806 5.28255C3.98199 6.58116 3.33268 8.15408 3.33268 10.0013C3.33268 11.8485 3.98199 13.4214 5.2806 14.7201C6.57921 16.0187 8.15213 16.668 9.99935 16.668Z",
    fill: "#696974"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.bde178c977b153991c36913c99db78b7.svg";
export { ForwardRef as ReactComponent };